import React, {useEffect, useState} from "react";

import './DeviceAlarmsTable.scss'
import PropTypes from "prop-types";
import {useRecoilValue} from "recoil";
import {grpcDeviceServiceSelector} from "../../state/grpc";
import {ADD, useToastContext} from "../Toast";
import {
  DataTable,
  DataTableSkeleton,
  IconButton,
  Pagination,
  Select,
  SelectItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableSelectAll,
  TableSelectRow,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  TextArea,
  TextInput,
  Toggle
} from "@carbon/react";
import {Add, Save, TrashCan} from '@carbon/react/icons';
import ConfirmDialog from "../ConfirmDialog";

const DeviceAlarmsTable = (props) => {
  const device = props.device
  const headers = [{
    key: 'alarmCode', header: 'Codice allarme'
  }, {
    key: 'severity', header: 'Priorità'
  }, {
    key: 'initialOffset', header: 'Ritardo (secondi)'
  }, {
    key: 'delay', header: 'Riproposizione (secondi)'
  }, {
    key: 'readme', header: 'Indicazioni'
  }, {
    key: 'disabled', header: 'Disabilitato'
  }, {
    key: 'h24Disabled', header: 'H24 Disabilitato'
  }, {
    key: 'isManual', header: 'Manuale'
  },
  ];
  const deviceService = useRecoilValue(grpcDeviceServiceSelector)
  const {toastDispatch} = useToastContext();
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)
  const [deviceAlarms, setDeviceAlarms] = useState([])
  const [firstRowIndex, setFirstRowIndex] = useState(0)
  const [pageSize, setPageSize] = useState(25)
  const [deleteModalOpened, setDeleteModalOpened] = useState(false)
  const [deleteModalId, setDeleteModalId] = useState(null)

  const getDeviceAlarms = () => {
    const req = new proto.api.ListDeviceAlarmsRequest()
    req.setDeviceId(device.id)
    setLoading(true)
    deviceService.listDeviceAlarms(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        setDeviceAlarms(resp.toObject().devicealarmsList)
        setError(false)
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    getDeviceAlarms()
  }, [])

  if (loading) {
    return (
      <DataTableSkeleton
        columnCount={headers.length + 1}
        rowCount={5}
        headers={headers}
      />
    )
  }

  if (error) {
    return (
      <span>ERROR!</span>
    )
  }

  const handlePaginationChange = (page, newPageSize) => {
    if (newPageSize !== pageSize) {
      setPageSize(newPageSize);
    }
    setFirstRowIndex(newPageSize * (page - 1));
  }

  const processChildren = (id, cell) => {
    let value = cell.value
    switch (cell.info.header) {
      case "alarmCode": {
        return (
          <TextInput
            id="alarm-code"
            labelText=""
            hideLabel={true}
            placeholder="Codice allarme"
            required={true}
            value={cell.value}
            type="text"
            onChange={(ev) => {
              setDeviceAlarms(
                deviceAlarms.map((row) => ({
                  ...row,
                  alarmCode: row.id === id ? ev.target.value : row.alarmCode,
                  draft: row.id === id ? true : row.draft,
                }))
              );
            }}
          />
        )
      }
      case "severity": {
        return (
          <Select
            hideLabel={true}
            id="alarm-priority"
            data-modal-primary-focus
            value={cell.value}
            onChange={ev => {
              setDeviceAlarms(
                deviceAlarms.map((row) => ({
                  ...row,
                  severity: row.id === id ? ev.target.value : row.severity,
                  draft: row.id === id ? true : row.draft,
                }))
              );
            }}>
            <SelectItem text="Grave" value="Grave"/>
            <SelectItem text="Lieve" value="Lieve"/>
            <SelectItem text="Informativo" value="Informativo"/>
          </Select>
        )
      }
      case "initialOffset": {
        if (cell.value) {
          return (
            <TextInput
              id="alarm-initil-offset"
              labelText=""
              hideLabel={true}
              placeholder="Ritardo (secondi)"
              required={true}
              value={cell.value}
              type="text"
              onChange={(ev) => {
                setDeviceAlarms(
                  deviceAlarms.map((row) => ({
                    ...row,
                    initialOffset: row.id === id ? ev.target.value : row.initialOffset,
                    draft: row.id === id ? true : row.draft,
                  }))
                );
              }}
            />
          )
        }
        break
      }
      case "delay": {
        if (cell.value) {
          return (
            <TextInput
              id="alarm-delay"
              labelText=""
              hideLabel={true}
              placeholder="Riproposizione (secondi)"
              required={true}
              value={cell.value}
              type="text"
              onChange={(ev) => {
                setDeviceAlarms(
                  deviceAlarms.map((row) => ({
                    ...row,
                    delay: row.id === id ? ev.target.value : row.delay,
                    draft: row.id === id ? true : row.draft,
                  }))
                );
              }}
            />
          )
        }
        break
      }
      case "readme": {
        return (
          <TextArea
            id="alarm-readme"
            labelText=""
            rows={1}
            hideLabel={true}
            placeholder="Indicazioni"
            required={true}
            value={cell.value}
            type="text"
            onChange={(ev) => {
              setDeviceAlarms(
                deviceAlarms.map((row) => ({
                  ...row,
                  readme: row.id === id ? ev.target.value : row.readme,
                  draft: row.id === id ? true : row.draft,
                }))
              );
            }}
          />
        )
      }
      case "disabled": {
        value = cell.value ? "Si" : "No"
        return (
          <Toggle
            id="alarm-disabled"
            labelA="No"
            labelB="Si"
            toggled={cell.value}
            onToggle={(toggled) => {
              setDeviceAlarms(
                deviceAlarms.map((row) => ({
                  ...row,
                  disabled: row.id === id ? toggled : row.disabled,
                  draft: row.id === id ? true : row.draft,
                }))
              );
            }}
          />
        )
      }
      case "h24Disabled": {
        value = cell.value ? "Si" : "No"
        return (
          <Toggle
            id="alarm-h24-disabled"
            labelA="No"
            labelB="Si"
            toggled={cell.value}
            onToggle={(toggled) => {
              setDeviceAlarms(
                deviceAlarms.map((row) => ({
                  ...row,
                  h24Disabled: row.id === id ? toggled : row.h24Disabled,
                  draft: row.id === id ? true : row.draft,
                }))
              );
            }}
          />
        )
      }
      case "isManual": {
        value = cell.value ? "Si" : "No"
        return (
          <Toggle
            id="alarm-is-manual"
            labelA="No"
            labelB="Si"
            toggled={cell.value}
            onToggle={(toggled) => {
              setDeviceAlarms(
                deviceAlarms.map((row) => ({
                  ...row,
                  isManual: row.id === id ? toggled : row.isManual,
                  draft: row.id === id ? true : row.draft,
                }))
              );
            }}
          />
        )
      }
    }
    return (
      <>
        {value}
      </>
    )
  }

  const handleAddAlarmSkeleton = () => {
    const req = new proto.api.SaveDeviceAlarmRequest()
    const deviceAlarmReq = new proto.api.DeviceAlarm()
    deviceAlarmReq.setDeviceId(device.id)
    deviceAlarmReq.setAlarmCode("000")
    deviceAlarmReq.setInitialOffset(300)
    deviceAlarmReq.setDelay(900)
    deviceAlarmReq.setSeverity("Grave")
    deviceAlarmReq.setName("")
    deviceAlarmReq.setReadme("")
    deviceAlarmReq.setDisabled(false)
    deviceAlarmReq.setH24Disabled(false)
    deviceAlarmReq.setIsManual(false)
    req.setDevicealarm(deviceAlarmReq)
    deviceService.createDeviceAlarm(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione fallita",
            content: "Impossibile mappare nuovo allarme",
            kind: "error",
            caption: err.message
          }
        })
      } else {
        setDeviceAlarms((currentState) => [
          ...currentState,
          resp.toObject().devicealarm,
        ])
      }
    })
  }

  const handleSaveAlarm = (deviceAlarmId) => {
    const deviceAlarmLookup = deviceAlarms.filter(it => it.id === deviceAlarmId)
    if (deviceAlarmLookup.length !== 1) {
      toastDispatch({
        type: ADD,
        payload: {
          title: "Operazione fallita",
          content: "Impossibile salvare allarme",
          kind: "error",
          caption: "l'allarme con id " + deviceAlarmId + " non è stato trovato nella lista"
        }
      })
    }
    const deviceAlarm = deviceAlarmLookup[0]
    const req = new proto.api.SaveDeviceAlarmRequest()
    const deviceAlarmReq = new proto.api.DeviceAlarm()
    deviceAlarmReq.setId(deviceAlarmId)
    deviceAlarmReq.setDeviceId(deviceAlarm.deviceId)
    deviceAlarmReq.setAlarmCode(deviceAlarm.alarmCode)
    deviceAlarmReq.setInitialOffset(deviceAlarm.initialOffset)
    deviceAlarmReq.setDelay(deviceAlarm.delay)
    deviceAlarmReq.setSeverity(deviceAlarm.severity)
    deviceAlarmReq.setName(deviceAlarm.name)
    deviceAlarmReq.setDisabled(deviceAlarm.disabled)
    deviceAlarmReq.setReadme(deviceAlarm.readme)
    deviceAlarmReq.setH24Disabled(deviceAlarm.h24Disabled)
    deviceAlarmReq.setIsManual(deviceAlarm.isManual)
    req.setDevicealarm(deviceAlarmReq)
    deviceService.updateDeviceAlarm(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione fallita",
            content: "Impossibile salvare l'allarme",
            kind: "error",
            caption: err.message
          }
        })
      } else {
        setDeviceAlarms(
          deviceAlarms.map((row) => ({
            ...row,
            draft: row.id === deviceAlarmId ? false : row.draft,
          }))
        );
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione avvenuta con successo",
            content: "Configurazione allarme salvata con successo",
            kind: "success"
          }
        })
      }
    })
  }

  return (
    <DataTable
      rows={deviceAlarms}
      headers={headers}
      isSortable
      overflowMenuOnHover={false}
      render={(
        {
          rows,
          headers,
          getHeaderProps,
          getRowProps,
          getSelectionProps,
          getToolbarProps,
          onInputChange,
          getTableProps,
          getTableContainerProps,
        }) => {
        return (
          <TableContainer title="Mappatura allarmi"
                          description="Lista degli allarmi mappati per questo strumento" {...getTableContainerProps()}>
            <ConfirmDialog
              openState={deleteModalOpened}
              setOpenState={setDeleteModalOpened}
              heading={"Sei sicuro di voler resettare l'allarme?"}
              primaryButtonText="Resetta"
              onRequestSubmit={() => {
                const req = new proto.api.DeleteDeviceAlarmRequest()
                req.setDeviceAlarmId(deleteModalId)
                deviceService.deleteDeviceAlarm(req, null, (err) => {
                  if (err != null) {
                    console.error(err)
                    toastDispatch({
                      type: ADD,
                      payload: {
                        title: "Operazione fallita",
                        content: "Impossibile resettare l'allarme",
                        kind: "error",
                        caption: err.message
                      }
                    })
                  } else {
                    getDeviceAlarms()
                    setDeleteModalOpened(false)
                    toastDispatch({
                      type: ADD,
                      payload: {
                        title: "Operazione avvenuta con successo",
                        content: "Allarme resettato con successo",
                        kind: "success"
                      }
                    })
                  }
                })
              }}
            />
            <TableToolbar {...getToolbarProps()} >
              <TableToolbarContent>
                <TableToolbarSearch onChange={onInputChange} size="lg"/>
                <IconButton label="Mappa nuovo allarme" onClick={handleAddAlarmSkeleton}><Add/></IconButton>
              </TableToolbarContent>
            </TableToolbar>
            <Pagination
              totalItems={rows.length}
              backwardText="Precedente"
              forwardText="Successiva"
              pageSize={25}
              pageSizes={[10, 25, 50, 100]}
              itemsPerPageText="Elementi per pagina"
              pageRangeText={(_current, total) => `di ${total} ${total === 1 ? 'pagina' : 'pagine'}`}
              itemRangeText={(min, max, total) => `${min}–${max} of ${total} elementi`}
              onChange={({page, pageSize}) => handlePaginationChange(page, pageSize)}
            />
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  <TableSelectAll {...getSelectionProps()} />
                  {headers.map((header) => (<TableHeader {...getHeaderProps({header})}>
                    {header.header}
                  </TableHeader>))}
                  <TableHeader style={{width: "1rem"}} scope="col"/>
                  <TableHeader style={{width: "1rem"}} scope="col"/>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(firstRowIndex, firstRowIndex + pageSize)
                  .map((row) => {
                    return {
                      deviceAlarm: deviceAlarms.find(it => it.id === row.id),
                      ...row
                    }
                  })
                  .map((row) => (
                    <TableRow key={row.id} {...getRowProps({row})}>
                      <TableSelectRow {...getSelectionProps({row})} />
                      {row.cells.map((cell) => (
                        <TableCell key={cell.id}>
                          {processChildren(row.id, cell)}
                        </TableCell>
                      ))}
                      <TableCell className="cds--table-column-menu">
                        <IconButton
                          disabled={!row.deviceAlarm.draft}
                          className="device-alarms-save-alarm-btn" kind="tertiary" size="sm" label="Salva"
                          onClick={() => handleSaveAlarm(row.id)}>
                          <Save/>
                        </IconButton>
                      </TableCell>
                      <TableCell className="cds--table-column-menu">
                        <IconButton
                          className="device-alarms-delete-alarm-btn" kind="tertiary" size="sm" label="Resetta"
                          onClick={() => {
                            setDeleteModalId(row.id)
                            setDeleteModalOpened(true)
                          }}>
                          <TrashCan/>
                        </IconButton>
                      </TableCell>
                    </TableRow>))}
              </TableBody>
            </Table>
          </TableContainer>
        );
      }}
    />
  )
}

DeviceAlarmsTable.propTypes = {
  device: PropTypes.object.isRequired
}

export default DeviceAlarmsTable